
























































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { EventBus } from '@/utils/event-bus'
import { saveAs } from 'file-saver'
import { lookup } from 'mime-types'
import axios from 'axios'

@Component
export default class ViewResourceViewsModal extends Vue {
  showModal = false;
  @Prop() resources?: any[];
  @Prop() markets?: any[] ;
  @Prop() marketKey?: string;

  fields: any[] = [
    { key: 'actions', label: 'Actions', class: 'text-center' },
    { key: 'name', label: 'Name' },
    { key: 'fileext', label: 'File type', class: 'text-center' },
    { key: 'previewCount', label: 'Previews', class: 'text-center' },
    { key: 'downloadCount', label: 'Downloads' }
    // { key: 'tagname', label: 'Tags' }
  ];

  currentPage = 1;
  perPage = 15;
  selectedProduct = null;
  get listOfProducts () {
    return this.$store.getters.getProducts
  }

  get currentMarket () {
    if (this.markets) {
      const market = this.markets.find((market: any) => market.value === this.marketKey)
      return market.text
    }
    return ''
  }

  get sortedResources () {
    const resourcesToShow = this.resources?.filter((resource: any) => {
      return this.selectedProduct ? resource.products.includes(this.selectedProduct) : true
    })
    return resourcesToShow?.sort((a: { downloadCount: number; }, b: { downloadCount: number; }) => b.downloadCount - a.downloadCount).slice(0, 100)
  }

  get rows () {
    const resourcesToShow = this.resources?.filter((resource: any) => {
      return this.selectedProduct ? resource.products.includes(this.selectedProduct) : true
    })
    return resourcesToShow?.length
  }

  onProductChange () {
    console.log('Product changed to:', this.selectedProduct)
  }

  async downloadFile (resource: any) {
    EventBus.$emit('show-loader')
    const resp = await axios.get(`resources/download/${resource.key}`, { withCredentials: true, responseType: 'blob' })
    if (!resp || resp.status !== 200) {
      EventBus.$emit('hide-loader')
      return
    }
    // log event
    this.$store.dispatch('addEvent', { description: 'Resource download', data: { key: resource.key }, title: 'Resource download', eventType: 3, userAgent: navigator.userAgent, product: null, market: { key: this.$store.getters.getSelectedMarket }, trackingKey: resource.trackingkey })
    const _blob = new Blob([resp.data], { type: lookup(resource.filename as string) || undefined })
    saveAs(_blob, resource.filename)
    EventBus.$emit('hide-loader')
  }
}
